/**
 * CustomerQuotesPage — a customer's Quotes tab, `/customers/:customerId/quotes`:
 * the Quotes list fixed to one customer, inside the customer's frame. Their
 * Tharstern estimates are the Estimates tab. The customer's id is its
 * Tharstern account code, which the list filters on.
 */
import { useCustomerRouteId } from "../app/components/domain/customers/useCustomerRouteId";
import { CustomerFrame } from "../app/components/domain/customers/CustomerFrame";
import { QuotesList } from "../app/components/domain/quotes/QuotesList";

export function CustomerQuotesPage() {
  const customerId = useCustomerRouteId();
  if (customerId === null) return null;
  return (
    <CustomerFrame customerId={customerId} current="quotes">
      <QuotesList customerKey={customerId} />
    </CustomerFrame>
  );
}
